import Firebase from 'firebase'

var config = {
    apiKey: "AIzaSyAJN9shYsqm2yy-jCeT7nLGLBMsqYJ1seg",
    authDomain: "kigebu-b72f2.firebaseapp.com",
    databaseURL: "https://kigebu-b72f2.firebaseio.com",
    projectId: "kigebu-b72f2",
    storageBucket: "kigebu-b72f2.appspot.com",
    messagingSenderId: "173607805794"
  };
  

const firebaseApp = Firebase.initializeApp(config);
export const db = firebaseApp.database();